import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { usePreviousPregnanciesChartsDataContext } from './hooks/usePreviousPregnanciesChartsDataContext';
import './styles/Charts.css';

export const Indicators = () => {
    const { chartData } = usePreviousPregnanciesChartsDataContext();

    return (
        <div className="w-100 previous-pregnancies-indicators-container-dashboard">
            <Card 
                title="Total de Nascidos Vivos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.liveBirths || 0
                )}
            />
            <Card
                title="Total de Nascidos Mortos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.deathBirths || 0
                )}
            />
            <Card
                title="Total de Abortos Perda Fetal"
                value={number.formatToBRNumber(
                    chartData?.indicators?.abotantions || 0
                )}
            />
            <Card
                title="Total de Partos Normais"
                value={number.formatToBRNumber(
                    chartData?.indicators?.normalBirths || 0
                )}
            />
            <Card
                title="Total de Partos Cesários"
                value={number.formatToBRNumber(
                    chartData?.indicators?.cesareanBirths || 0
                )}
            />
        </div>
    );
};
